import React from "react";
import { applySpec } from "ramda";
import { connect } from "react-redux";
import {getEditMediaItemType} from "common/selectors";
import EditMediaInfoBook from "edit-media/components/EditMediaInfoBook";

const EditMediaInfoTab = ({ mediaItemType }) => (
  <div>
    {
      {
      BOOK: (<EditMediaInfoBook />),
      CHAPTER: (<EditMediaInfoBook />)
      }[mediaItemType]
    }
  </div>
);

const mapStateToProps = applySpec({
  mediaItemType: getEditMediaItemType,
});

export default connect(mapStateToProps)(EditMediaInfoTab);
